import { Channel } from 'lib-shared-types-channels';

import { AIImproveWritingPromptName } from 'apis/ai';
import { UserStorageAgentCopilot } from 'apis/userStorage';
import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';

type DisabledImprovement = AIImproveWritingPromptName;

export const pinnableActionFeatureFlags = [
  'agent-copilot-pin-actions',
] as const;
export type PinnableFeatureFlags = (typeof pinnableActionFeatureFlags)[number];

export type ConditionArgs = {
  flags: ReturnType<typeof useFeatureFlag<PinnableFeatureFlags>>;
  pinState: Required<
    NonNullable<NonNullable<UserStorageAgentCopilot['agent_copilot']>['pinned']>
  >;
};
export type PinnableAction = {
  id: PinnableActionId;
  component: (props: PinnedActionProps) => JSX.Element | null;
  condition: (args: ConditionArgs) => boolean;
  label?: string;
  disabledImprovements?: DisabledImprovement[];
};

export type PinnableActionId =
  | 'improveReply'
  | 'improveReplyMatchStyleGuide'
  | 'checkSpellingAndGrammar'
  | 'translateToConversationLanguage'
  | 'expandText';

export interface PinnedActionProps {
  text: string | 'html';
  pinnableActions: PinnableAction[];
  languageCode?: string;
  label?: string;
  channel?: Channel;
  disabledImprovements?: DisabledImprovement[];
  csid?: string;
}
